export { default as profile } from './profile';
export { default as timeline } from './timeline';
export { default as projects } from './projects';
export { default as diary } from './diary';
export { default as stack } from './stack';
export { default as testimonials } from './testimonials';
